// Martial arts data: rank ladders, focus types, themed imagery.

export const martialArts = [
  {
    id: 'bjj',
    name: 'Brazilian Jiu-Jitsu',
    shortName: 'BJJ',
    image: '/generated/martial-bjj.png',
    accent: '#1e40af',
    ranks: [
      { id: 'white', name: 'White Belt', color: '#f5f5f4' },
      { id: 'blue', name: 'Blue Belt', color: '#1e40af' },
      { id: 'purple', name: 'Purple Belt', color: '#6b21a8' },
      { id: 'brown', name: 'Brown Belt', color: '#78350f' },
      { id: 'black', name: 'Black Belt', color: '#0a0a0a' },
    ],
    hasStripes: true,
    maxStripes: 4,
    description: 'The Gentle Art. Ground-based grappling: positions, submissions, escapes, and flow.',
    focusAreas: ['Gi', 'No-Gi', 'Drilling', 'Live Rolling', 'Open Mat', 'Competition Prep', 'Conditioning'],
  },
  {
    id: 'muay-thai',
    name: 'Muay Thai',
    shortName: 'Muay Thai',
    image: '/generated/martial-muay-thai.png',
    accent: '#dc2626',
    ranks: [
      { id: 'white', name: 'White Pra Jiad', color: '#f5f5f4' },
      { id: 'yellow', name: 'Yellow Pra Jiad', color: '#facc15' },
      { id: 'green', name: 'Green Pra Jiad', color: '#16a34a' },
      { id: 'blue', name: 'Blue Pra Jiad', color: '#2563eb' },
      { id: 'brown', name: 'Brown Pra Jiad', color: '#78350f' },
      { id: 'red', name: 'Red Pra Jiad', color: '#dc2626' },
      { id: 'silver', name: 'Silver Pra Jiad', color: '#94a3b8' },
      { id: 'gold', name: 'Gold Pra Jiad', color: '#eab308' },
    ],
    description: 'The Art of Eight Limbs. Striking with fists, elbows, knees, and shins. Clinch work.',
    focusAreas: ['Padwork', 'Bagwork', 'Sparring', 'Clinch', 'Shadow Boxing', 'Drilling', 'Conditioning'],
  },
  {
    id: 'boxing',
    name: 'Boxing',
    shortName: 'Boxing',
    image: '/generated/martial-boxing.png',
    accent: '#7c2d12',
    ranks: [
      { id: 'beginner', name: 'Beginner', color: '#a3a3a3' },
      { id: 'novice', name: 'Novice', color: '#fbbf24' },
      { id: 'amateur', name: 'Amateur', color: '#c0c0c0' },
      { id: 'open-class', name: 'Open Class', color: '#facc15' },
      { id: 'pro', name: 'Professional', color: '#dc2626' },
    ],
    description: 'The Sweet Science. Hands only: footwork, head movement, angles, and timing.',
    focusAreas: ['Mittwork', 'Bagwork', 'Shadow Boxing', 'Sparring', 'Footwork Drills', 'Conditioning'],
  },
  {
    id: 'karate',
    name: 'Karate',
    shortName: 'Karate',
    image: '/generated/martial-karate.png',
    accent: '#ea580c',
    ranks: [
      { id: 'white', name: 'White (10th Kyu)', color: '#f5f5f4' },
      { id: 'yellow', name: 'Yellow (9th Kyu)', color: '#facc15' },
      { id: 'orange', name: 'Orange (8th Kyu)', color: '#f97316' },
      { id: 'green', name: 'Green (7th-6th Kyu)', color: '#16a34a' },
      { id: 'blue', name: 'Blue (5th Kyu)', color: '#2563eb' },
      { id: 'purple', name: 'Purple (4th Kyu)', color: '#6b21a8' },
      { id: 'brown', name: 'Brown (3rd-1st Kyu)', color: '#78350f' },
      { id: 'black-1', name: 'Black (1st Dan)', color: '#0a0a0a' },
      { id: 'black-2', name: 'Black (2nd Dan)', color: '#0a0a0a' },
      { id: 'black-3', name: 'Black (3rd Dan)', color: '#0a0a0a' },
      { id: 'black-4', name: 'Black (4th-5th Dan)', color: '#0a0a0a' },
    ],
    description: 'Empty Hand. Striking-focused with kata, kumite, and traditional forms.',
    focusAreas: ['Kata', 'Kumite (Sparring)', 'Kihon (Basics)', 'Bunkai', 'Weapons (Kobudo)', 'Conditioning'],
  },
  {
    id: 'judo',
    name: 'Judo',
    shortName: 'Judo',
    image: '/generated/martial-judo.png',
    accent: '#0c4a6e',
    ranks: [
      { id: 'white', name: 'White (Rokyu)', color: '#f5f5f4' },
      { id: 'yellow', name: 'Yellow (Gokyu)', color: '#facc15' },
      { id: 'orange', name: 'Orange (Yonkyu)', color: '#f97316' },
      { id: 'green', name: 'Green (Sankyu)', color: '#16a34a' },
      { id: 'blue', name: 'Blue (Nikyu)', color: '#2563eb' },
      { id: 'brown', name: 'Brown (Ikkyu)', color: '#78350f' },
      { id: 'black', name: 'Black (Shodan+)', color: '#0a0a0a' },
    ],
    description: 'The Gentle Way. Throws, takedowns, pins, and submissions in the gi.',
    focusAreas: ['Tachi-Waza (Standing)', 'Ne-Waza (Ground)', 'Randori (Sparring)', 'Uchikomi', 'Drilling', 'Conditioning'],
  },
  {
    id: 'wrestling',
    name: 'Wrestling',
    shortName: 'Wrestling',
    image: '/generated/martial-wrestling.png',
    accent: '#991b1b',
    ranks: [
      { id: 'novice', name: 'Novice', color: '#a3a3a3' },
      { id: 'jv', name: 'JV / Developmental', color: '#fbbf24' },
      { id: 'varsity', name: 'Varsity', color: '#dc2626' },
      { id: 'collegiate', name: 'Collegiate', color: '#1e40af' },
      { id: 'open', name: 'Open / Senior', color: '#0a0a0a' },
      { id: 'elite', name: 'Elite / National', color: '#d97706' },
    ],
    description: 'No quarter given. Takedowns, control, and pinning combinations.',
    focusAreas: ['Folkstyle', 'Freestyle', 'Greco-Roman', 'Live Wrestling', 'Drilling', 'Conditioning'],
  },
  {
    id: 'taekwondo',
    name: 'Taekwondo',
    shortName: 'TKD',
    image: '/generated/martial-taekwondo.png',
    accent: '#0369a1',
    // Default sequence = World Taekwondo (WT, formerly WTF) standard 10-geup
    // ladder with intermediate "tip" belts. Premium federation selector will
    // let users pick ITF, ATA, Kukkiwon-only, etc.
    ranks: [
      { id: 'white', name: 'White (10th Geup)', color: '#f5f5f4' },
      { id: 'white-yellow', name: 'White / Yellow Tip (9th Geup)', color: '#fef9c3' },
      { id: 'yellow', name: 'Yellow (8th Geup)', color: '#facc15' },
      { id: 'yellow-green', name: 'Yellow / Green Tip (7th Geup)', color: '#bbf7d0' },
      { id: 'green', name: 'Green (6th Geup)', color: '#16a34a' },
      { id: 'green-blue', name: 'Green / Blue Tip (5th Geup)', color: '#86efac' },
      { id: 'blue', name: 'Blue (4th Geup)', color: '#2563eb' },
      { id: 'blue-red', name: 'Blue / Red Tip (3rd Geup)', color: '#93c5fd' },
      { id: 'red', name: 'Red (2nd Geup)', color: '#dc2626' },
      { id: 'red-black', name: 'Red / Black Tip (1st Geup)', color: '#7f1d1d' },
      { id: 'black-1', name: 'Black (1st Dan)', color: '#0a0a0a' },
      { id: 'black-2', name: 'Black (2nd Dan)', color: '#0a0a0a' },
      { id: 'black-3', name: 'Black (3rd Dan+)', color: '#0a0a0a' },
    ],
    description: 'The Way of the Foot and Fist. Dynamic kicks, forms, and Olympic sparring.',
    focusAreas: ['Poomsae (Forms)', 'Kyorugi (Sparring)', 'Board Breaking', 'Kicking Drills', 'Conditioning'],
  },
  {
    id: 'mma',
    name: 'Mixed Martial Arts',
    shortName: 'MMA',
    image: '/generated/martial-mma.png',
    accent: '#581c87',
    ranks: [
      { id: 'fundamentals', name: 'Fundamentals', color: '#a3a3a3' },
      { id: 'intermediate', name: 'Intermediate', color: '#fbbf24' },
      { id: 'advanced', name: 'Advanced', color: '#dc2626' },
      { id: 'amateur', name: 'Amateur Competitor', color: '#1e40af' },
      { id: 'pro', name: 'Professional', color: '#0a0a0a' },
    ],
    description: 'Everything. Striking, grappling, takedowns, and cage work integrated.',
    focusAreas: ['Stand-up', 'Grappling', 'Wrestling', 'Cage Work', 'Sparring', 'Conditioning', 'Fight Prep'],
  },
];

export const getArtById = (id) => martialArts.find((a) => a.id === id);
